import React from 'react';
import {
    Route,
    Switch,
    Redirect,
    useParams,
} from 'react-router-dom';
import { Container } from './styled';
import Preview from './Preview';
import FieldMapping from './FieldMapping';
import Done from './Done';

function Export() {
    const params = useParams();

    return (
        <Container>
            <Switch>
                <Route exact path="/app/:groupId/export" component={FieldMapping} />
                <Route exact path="/app/:groupId/export/preview" component={Preview} />
                <Route exact path="/app/:groupId/export/done" component={Done} />
                <Redirect to={`/app/${params.groupId}/export`} />
            </Switch>
        </Container>
    );
}

export default Export;
